<template>
  <v-row align="center" justify="center">
    <v-col v-if="error" cols="12">
      <div class="text-center grey--text">
        Something went wrong, please contact your event organiser.
      </div>
    </v-col>
    <v-col cols="12" sm="8" md="6">
      <AddEditSponsorDetails
        v-if="sponsor != null"
        :sponsor="sponsor"
        :isSponsorsMode="true"
        :event="event"
      />
    </v-col>
  </v-row>
</template>

<script>
import AddEditSponsorDetails from "@/components/MultiConnect/AddEditSponsorDetails";
import Event from "@/models/Event";
import {getEventDoc} from "@/shared/firebase_utils";

export default {
  async created() {
    this.eventId = this.$route.params.eventId;
    this.sponsorsUid = this.$route.params.sponsorsUid;
    try {
      let eventDoc = await getEventDoc(this.eventId);
      // let eventData = eventDoc.data();
      if (eventDoc.exists) {
        this.event = Event.fromFireStore(eventDoc);
        this.sponsor = this.event.sponsors.find(
          (sponsor) => sponsor.uid == this.sponsorsUid
        );
        console.log(" this.sponsor: ", this.sponsor);

        console.log("eventData: ", eventDoc.data());
      } else {
        this.error = true;
      }
    } catch (error) {
      console.log("Error occurred while fetching doc: ", error);
    }
  },
  data() {
    return {
      eventId: "",
      sponsorsUid: "",
      event: null,
      sponsor: null,
      error: false,
    };
  },
  components: {
    AddEditSponsorDetails,
  },
};
</script>

<style>
</style>